import { getAllPermissions } from '@principle-theorem/feature-flags';
import { uniq } from 'lodash';
import { APPOINTMENTS_FEATURE } from './appointments';
import { AI_RECEPTIONIST_FEATURE } from './ai-receptionist';
import { AI_SCRIBE_FEATURE } from './ai-scribe';
import { BRANDS_FEATURE } from './brands';
import { CALENDAR_FEATURE } from './calendar';
import {
  ADF_SERVICE_PROVIDER_FEATURE,
  FUNDING_REQUESTS_FEATURE,
  PHYSIOTHERAPY_SERVICE_PROVIDER_FEATURE,
} from './claims';
import { CONTACTS_FEATURE } from './contacts';
import {
  HICAPS_CONNECT_FEATURE,
  HICAPS_CONNECT_TESTING_FEATURE,
} from './hicaps';
import { INTEGRATIONS_FEATURE } from './integrations';
import { LABS_FEATURE } from './labs';
import { MANAGEMENT_FEATURE } from './management';
import { ORGANISATION_FEATURE } from './organisation';
import { PATIENTS_FEATURE } from './patients';
import { PRACTICES_FEATURE } from './practices';
import { REPORTING_FEATURE } from './reporting';
import { SEEDING_FEATURE } from './seeding';
import { SETUP_WIZARD_FEATURE } from './setup-wizard';
import { STAFF_FEATURE } from './staff';
import { TYRO_TESTING_FEATURE } from './tyro';
import { PRACTICE_STAFFER_FEE_SCHEDULES_FEATURE } from './fee-schedules';

export const ALL_FEATURES = [
  AI_RECEPTIONIST_FEATURE,
  AI_SCRIBE_FEATURE,
  APPOINTMENTS_FEATURE,
  BRANDS_FEATURE,
  CALENDAR_FEATURE,
  CONTACTS_FEATURE,
  FUNDING_REQUESTS_FEATURE,
  HICAPS_CONNECT_FEATURE,
  HICAPS_CONNECT_TESTING_FEATURE,
  INTEGRATIONS_FEATURE,
  LABS_FEATURE,
  MANAGEMENT_FEATURE,
  ORGANISATION_FEATURE,
  PATIENTS_FEATURE,
  PRACTICE_STAFFER_FEE_SCHEDULES_FEATURE,
  PHYSIOTHERAPY_SERVICE_PROVIDER_FEATURE,
  ADF_SERVICE_PROVIDER_FEATURE,
  PRACTICES_FEATURE,
  REPORTING_FEATURE,
  SEEDING_FEATURE,
  SETUP_WIZARD_FEATURE,
  STAFF_FEATURE,
  TYRO_TESTING_FEATURE,
];

export const ALL_PERMISSIONS = uniq(getAllPermissions(ALL_FEATURES));
